import React, {useEffect, useState, useRef} from 'react';
import styled from "styled-components";
import AppLayout from "@layouts/app.layout";
import {getCityURL} from "../models/district";
import Navbar from "@organisms/navbar/navbar";
import WelcomeSchema from "@molecules/schema/welcome";
import IsRealtorBanner from "@molecules/banners/is.realtor";
import IsOwnerBanner from "@molecules/banners/is.owner";
import Stats from '@molecules/stats/stats';
import {handleFooterLinks} from "@organisms/footer/helpers";
import {handleNavbarLinks} from "@organisms/navbar/helpers";
import {isEmpty} from "@helpers/helpers";
import {useWindowSize} from "@helpers/windows.size";
import {scrollToRef} from "@helpers/helpers";
import WelcomeMainSection from "../components/organisms/welcome/main_section";
import WelcomeSelectCities from "../components/organisms/welcome/select_cities";
import WelcomeIntroductionSection from "../components/organisms/welcome/introduction_section";
import WelcomeRealtorsLogos from "../components/organisms/welcome/realtors_logos";
import '@assets/scss/swiper/swiper.scss';

const statItems = [
    {num: '1000000', label: ' ملک‌ آگهی‌شده در ۲نبش'},
    {num: '11000', label: 'مشاور فعال ۲نبش در سرتاسر ایران'},
    {num: '2000000', label: 'بازدید ماهانه از ۲نبش'},
];

function Welcome({navbarLinks, footerLinks, defaultCityId}) {
    const counterUpRef = useRef('');
    const citiesSearchRef = useRef('');
    const windowSize = useWindowSize();

    const [startCounterUp, setStartCounterUp] = useState(false);


    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = document.documentElement.scrollTop;

            const navbar = document.querySelector('.welcome-navbar');

            if (scrollTop > 100) {
                if (!isEmpty(navbar) && navbar.classList.contains('bg-transparent')) {
                    navbar.classList.remove('bg-transparent');
                }
            } else {
                if (!isEmpty(navbar) && !navbar.classList.contains('bg-transparent')) {
                    navbar.classList.add('bg-transparent');
                }
            }

            const target = counterUpRef.current;
            const positionFilter = (windowSize > 992) ? 20 : 100;
            const position = ((target.offsetHeight - positionFilter) + scrollTop) > target.offsetTop;

            if (position && !startCounterUp) {
                setStartCounterUp(true);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll)
    });

    const handleScrollToCities = () => {
        scrollToRef(citiesSearchRef, (windowSize > 991 ? 160 : 88))
    };

    return (
        <AppLayout
            footerLinks={footerLinks}
            selectedCityId={defaultCityId}
            pageCanonicalLink="/"
            pageTitle="۲نبش راهی سریع و مطمئن برای خانه‌دار شدن"
            pageDescription="سایت ۲نبش با بیش از ۱۱هزار مشاور املاک، راهنمای سریع و مطمئن شما در مسیر خانه‌دار شدن است. ۲نبش همچنین سامانه‌ای مناسب برای افزایش معاملات مشاورین املاک است"
        >
            <Container>

                <Navbar
                    inPage="home"
                    navbarLinks={navbarLinks}
                    selectedCityId={defaultCityId}
                    fixed
                    className="welcome-navbar bg-transparent"
                />

                <WelcomeMainSection handleScrollToCities={handleScrollToCities}/>

                <Section className="container" ref={citiesSearchRef}>
                    <WelcomeSelectCities/>
                </Section>

                <Section className="container">
                    <WelcomeIntroductionSection/>
                </Section>

                <Section className="container" ref={counterUpRef}>
                    <Stats statItems={statItems} className="mt-24 mt-lg-0" carouselClassName=""/>
                </Section>

                <Section className="container">
                    <IsRealtorBanner/>
                </Section>

                <Section className="container sm-fluid">
                    <WelcomeRealtorsLogos/>
                </Section>

                <Section className="container">
                    <IsOwnerBanner/>
                </Section>
            </Container>

            <WelcomeSchema/>
        </AppLayout>
    )
}

Welcome.getInitialProps = async (context) => {
    const {store, isServer, query, req, res} = context;
    let defaultCityId = 259;

    if (!isEmpty(req) && !isEmpty(req.cookies) && !isEmpty(req.cookies.default_city_id)) {

        if (!isNaN(Number(req.cookies.default_city_id))) {
            defaultCityId = req.cookies.default_city_id;

            const city_url = await getCityURL(Number(req.cookies.default_city_id));

            if (res) {
                if (!isEmpty(city_url)) {
                    return res.redirect(302, '/' + city_url);
                } else {
                    res.cookie('default_city_id', '', {maxAge: 0}); // Expire now
                }
            }
        } else if (res) {
            res.cookie('default_city_id', '', {maxAge: 0}); // Expire now
        }
    }

    const footerLinks = await handleFooterLinks(defaultCityId);
    const navbarLinks = await handleNavbarLinks(defaultCityId);

    return {
        navbarLinks: navbarLinks,
        footerLinks: footerLinks,
        defaultCityId: defaultCityId
    };
};

export default Welcome;

// styles

const Container = styled.div`
    padding-bottom: 104px;
    
    @media(max-width: ${props => props.theme.screenSmMax}) {
        padding-bottom: 96px;
    }
`;


const Section = styled.section`
    margin-top: 80px;
    
    @media(max-width: ${props => props.theme.screenXsMax}) {
        margin-top: 64px;
    }
    
    .swiper-slide {
        margin: 0;
    }
    
    .carousel-pagination {
        @media(min-width: ${props => props.theme.screenXsMax}) {
            display: none;
        }
    }
`;
